import React from 'react';

const ClockIcon = ({
  size = 56,                        // total diameter in px
  bgColor = '#FFF7D6',             // pale yellow background
  strokeColor = '#D97706',         // orange clock outlines/hands
  strokeWidth = 3,                 // thickness of the clock ring & hands
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Background circle */}
    <circle cx="28" cy="28" r="28" fill={bgColor} />

    {/* Clock face ring */}
    <circle
      cx="28"
      cy="28"
      r="18"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
    />

    {/* Hour & minute hands */}
    <path
      d="M28 20V28L36 32"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ClockIcon;
